import useMaintenanceStore, { MaintenanceStatus } from "./store";

/** CloudFront caches the endpoint for 30s, so anything more frequent re-reads the same body. */
const MINIMUM_INTERVAL_MS = 30_000;

const fetchStatus = async () => {
  if (Date.now() - useMaintenanceStore.getState().lastFetchedAt < MINIMUM_INTERVAL_MS) return;

  useMaintenanceStore.setState({ lastFetchedAt: Date.now() });

  try {
    const response = await fetch("/maintenance", { cache: "no-store" });

    useMaintenanceStore.setState(MaintenanceStatus.parse(await response.json()));
  } catch {
    // Missing, unreachable or malformed all mean the same thing: carry on as normal.
  }
};

const initMaintenanceStatus = (isSelfHosted: boolean) => {
  if (isSelfHosted) return;

  fetchStatus();

  // A tab left open would otherwise never learn that a window opened or closed.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") fetchStatus();
  });
};

export default initMaintenanceStatus;
